const state = {
  searchInputs: {},
  filters: {},
  dataTables: {},
  reloadDataTables: [],
}

const mutations = {
  clear(state) {
    state.searchInputs = {}
    state.filters = {}
    state.dataTables = {}
    state.reloadDataTables = []
  },
  setSearchInputs(state, payload) {
    state.searchInputs = payload
  },
  setFilters(state, payload) {
    state.filters = payload
  },
  setDataTables(state, payload) {
    state.dataTables = payload
  },
  setReloadDataTables(state, payload) {
    state.reloadDataTables = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}